import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var dashboardRes;
export const dashboardTodo = createAsyncThunk('dashboard', async () => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'dashboard',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return dashboardRes = res.data
    } catch (error) {
        return dashboardRes = error.response.data
    }
})


const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(dashboardTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('dashboard', state.data)
            }
        });
        builder.addCase(dashboardTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default dashboardSlice.reducer; 